import { UsersService, PermissionsService } from 'shared/services';
import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import isEmpty from 'lodash/isEmpty';


//  Actions
const LOGIN_REQUEST = 'users/LOGIN_REQUEST';
const LOGIN_SUCCESS = 'users/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'users/LOGIN_FAILURE';
const LOGOUT_SUCCESS = 'users/LOGOUT_SUCCESS';
const LOGOUT_FAILURE = 'users/LOGOUT_FAILURE';
const GET = 'users/GET_LOADING';
const GET_SUCCESS = 'users/GET_SUCCESS';
const GET_ERROR = 'users/GET_ERROR';
const GET_USER = 'users/GET_USER_LOADING';
const GET_USER_SUCCESS = 'users/GET_USERS_SUCCESS';
const GET_USER_ERROR = 'users/GET_USER_ERROR';
const GET_ROLES = 'users/GET_ROLES_LOADING';
const GET_ROLES_SUCCESS = 'users/GET_ROLES_SUCCESS';
const GET_ROLES_ERROR = 'users/GET_ROLES_ERROR';
const GET_TERMS_SUCCESS = 'users/GET_TERMS_SUCCESS';
const GET_TERMS_ERROR = 'users/GET_TERMS_ERROR';
const UPDATE_USER_LOADING = 'users/UPDATE_USER_LOADING';
const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
const UPDATE_USER_ERROR = 'users/UPDATE_USER_ERROR';
const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
const CREATE_USER_ERROR = 'users/CREATE_USER_ERROR';
const CREATE_PERSONNEL_SUCCESS = 'users/CREATE_PERSONNEL_SUCCESS';
const CREATE_PERSONNEL_ERROR = 'users/CREATE_PERSONNEL_ERROR';
const CHANGE_PASSWORD_SUCCESS = 'users/CHANGE_PASSWORD_SUCCESS';
const CHANGE_PASSWORD_ERROR = 'users/CHANGE_PASSWORD_ERROR';
const GET_SECURITY_QUESTIONS_SUCCESS = 'users/GET_SECURITY_QUESTIONS_SUCCESS';
const GET_SECURITY_QUESTIONS_ERROR = 'users/GET_SECURITY_QUESTIONS_ERROR';
const VERIFY_USER_SUCCESS = 'users/VERIFY_USER_SUCCESS';
const VERIFY_USER_ERROR = 'users/VERIFY_USER_ERROR';
const UPDATE_FORGOT_PASSWORD_SUCCESS = 'users/UPDATE_FORGOT_PASSWORD_SUCCESS';
const UPDATE_FORGOT_PASSWORD_ERROR = 'users/UPDATE_FORGOT_PASSWORD_ERROR'
const RESEND_VERIFICATION = 'users/RESEND_VERIFICATION';
const RESET_USER = 'users/RESET_USER';
const GET_PERSONNEL = 'users/GET_PERSONNEL';

const initialState = {
  users: [],
  currentUser: {},
  securityQuestions: [],
  roles: [],
  updated: false,
  usersLoaded: false,
  userLoaded: false,
  rolesLoaded: false,
  isLoading: false,
  isLoadingUpdate: false,
  loginToken: '',
  terms: '',
  verifiedUser: null,
  logOutSuccess: false,
  verificationSent: false,
  userCreated: false,
  cognitoUserCreated: false,
  errorUpdateUser: false,
};

//  Reducer
export default function usersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        auth: action.data,
        isLoading: false,
        error: null,
      });
    case LOGIN_FAILURE:
      return Object.assign({}, state, {
        fetchError: true,
        error: action.error,
        isLoading: false,
      });
    case LOGOUT_FAILURE:
      return Object.assign({}, state, {
        logOutSuccess: false,
        error: action.error,
      });
    case GET:
      return Object.assign({}, state, { usersLoaded: false });
    case GET_SUCCESS: {
      return Object.assign({}, state, { users: action.users, usersLoaded: true, error: null });
    }
    case GET_ERROR:
      return { ...state, error: action.error };
    case GET_USER:
      return Object.assign({}, state, { userLoaded: false });
    case GET_USER_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...action.currentUser,
          testCenterEventPersonnels: state.currentUser.testCenterEventPersonnels || [],
          testCenterCyclePersonnels: state.currentUser.testCenterCyclePersonnels || []
        },
        userLoaded: true,
        error: null,
      };
    case GET_USER_ERROR:
      return {
        ...state,
        error: true,
      };
    case UPDATE_USER_LOADING:
      return Object.assign({}, state, {
        isLoadingUpdate: true,
        errorUpdateUser: false,
      });
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...action.updatedUser,
          testCenterEventPersonnels: state.currentUser.testCenterEventPersonnels || [],
          testCenterCyclePersonnels: state.currentUser.testCenterCyclePersonnels || []
        },
        updated: true,
        isLoadingUpdate: false,
        errorUpdateUser: false,
      };
    case GET_PERSONNEL:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          testCenterEventPersonnels: action.event[0],
          testCenterCyclePersonnels: action.event[1],
        },
      };
    case UPDATE_USER_ERROR:
      return Object.assign({}, state, { errorUpdateUser: !!action.error || !isEmpty(action.error), isLoadingUpdate: false, updated: false });
    case GET_ROLES:
      return state;
    case GET_ROLES_SUCCESS:
      return Object.assign({}, state, { roles: action.data, rolesLoaded: true, error: null });
    case GET_ROLES_ERROR:
      return Object.assign({}, state, { error: action.error, rolesLoaded: false });
    case GET_TERMS_SUCCESS:
      return {
        ...state,
        terms: action.terms.Terms,
        tncVersion: action.terms.UUID,
        error: null,
      };
    case GET_TERMS_ERROR:
      return { ...state, error: action.error };
    case CREATE_USER_SUCCESS:
      return { ...state, currentUser: { ...state.currentUser, ...action.user }, cognitoUserCreated: true, error: null };
    case CREATE_USER_ERROR:
      return { ...state, error: action.error.Error || action.error.message };
    case CREATE_PERSONNEL_SUCCESS:
      return { ...state, currentUser: { ...state.currentUser, ...action.user }, userCreated: !isEmpty(action.user), error: null };
    case CREATE_PERSONNEL_ERROR:
      return { ...state, error: action.error };
    case RESET_USER:
      return { ...state, userCreated: false, cognitoUserCreated: false };
    case GET_SECURITY_QUESTIONS_SUCCESS:
      return { ...state, securityQuestions: action.questions.Questions, error: null };
    case GET_SECURITY_QUESTIONS_ERROR:
      return { ...state, securityQuestions: [], error: action.error };
    case VERIFY_USER_SUCCESS:
      return { ...state, verifiedUser: true };
    case VERIFY_USER_ERROR:
      return {
        ...state,
        verifiedUser: false,
        error: { message: action.error.Error || action.error.message },
      };
    case UPDATE_FORGOT_PASSWORD_SUCCESS:
      return { ...state };
    case UPDATE_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        error: { message: action.error.Error || action.error.message },
      };
    case RESEND_VERIFICATION:
      return {
        ...state,
        verificationSent: !!action.result.data,
        error: !action.result.loading && action.result.error,
      };
    default:
      return state;
  }
}

export function generalError(error) {
  return { type: GET_ERROR, error };
}

//  Action Creators
export function getTokenLoading() {
  return { type: LOGIN_REQUEST };
}

export function getTokenSuccess(data) {
  return { type: LOGIN_SUCCESS, data };
}

export function getTokenError(error) {
  return { type: LOGIN_FAILURE, error };
}

export function logoutSuccess(data) {
  return { type: LOGOUT_SUCCESS, data };
}

export function logoutError(error) {
  return { type: LOGOUT_FAILURE, error };
}


export function getUsersLoading() {
  return { type: GET };
}

export function getUsersSuccess(users) {
  return { type: GET_SUCCESS, users };
}

export function getUsersError(error) {
  return { type: GET_ERROR, error };
}

export function getUserLoading() {
  return { type: GET_USER };
}

export function getPersonnel(event) {
  return { type: GET_PERSONNEL,event };
}

export function getUserSuccess(currentUser) {
  return { type: GET_USER_SUCCESS, currentUser };
}

export function getUserError(error) {
  return { type: GET_USER_ERROR, error };
}

export function updateUserLoading() {
  return { type: UPDATE_USER_LOADING};
}

export function updateUserSuccess(updatedUser) {
  return { type: UPDATE_USER_SUCCESS, updatedUser };
}

export function updateUserError(error) {
  return { type: UPDATE_USER_ERROR, error };
}

export function clearUserError() {
  return { type: UPDATE_USER_ERROR };
}

export function getRolesLoading() {
  return { type: GET_ROLES };
}

export function getRolesSuccess(data) {
  return { type: GET_ROLES_SUCCESS, data };
}

export function getRolesError(error) {
  return { type: GET_ROLES_ERROR, error };
}

export function getTermsSuccess(terms) {
  return { type: GET_TERMS_SUCCESS, terms };
}

export function createUserSuccess() {
  return { type: CREATE_USER_SUCCESS, user: {} };
}

export function createUserError(error) {
  return { type: CREATE_USER_ERROR, error };
}

export function createPersonnelSuccess(user) {
  return { type: CREATE_PERSONNEL_SUCCESS, user };
}

export function createPersonnelError(error) {
  return { type: CREATE_PERSONNEL_ERROR, error };
}

export function getSecurityQuestionsSuccess(questions) {
  return { type: GET_SECURITY_QUESTIONS_SUCCESS, questions };
}

export function getSecurityQuestionsError(error) {
  return { type: GET_SECURITY_QUESTIONS_ERROR, error };
}

export function verifyUserSuccess() {
  return { type: VERIFY_USER_SUCCESS };
}

export function verifyUserError(error) {
  return { type: VERIFY_USER_ERROR, error };
}

export function changePasswordSuccess() {
  return { type: CHANGE_PASSWORD_SUCCESS };
}

export function changePasswordError(error) {
  return { type: CHANGE_PASSWORD_ERROR, error };
}

export function updateForgotPasswordSuccess(questions) {
  return { type: UPDATE_FORGOT_PASSWORD_SUCCESS, questions };
}

export function updateForgotPasswordError(error) {
  return { type: UPDATE_FORGOT_PASSWORD_ERROR, error };
}

export function resendVerificationAction(result) {
  return { type: RESEND_VERIFICATION, result };
}

export function resetUserAction() {
  return { type: RESET_USER };
}
//  Action dispatcher functions
export function getUserLogin(username, password) {
  return function (dispatch) {
    dispatch(getTokenLoading());
    return UsersService.getUserToken(username, password)
      .then((response) => {
        if (response[0]) {
          dispatch(getTokenSuccess(response[0]));
        } else {
          dispatch(getTokenError(response[0]));
        }
      })
      .catch((error) => {
        dispatch(getTokenError(error.data));
      });
  };
}

export function getUser(username) {
  return function (dispatch) {
    return UsersService.getUser(username)
      .then((response) => {
        dispatch(getUserSuccess(response));
      })
      .catch((error) => {
        dispatch(getUserError(error.data));
      });
  };
}

export function loginUser(data) {
  return function (dispatch) {
    return UsersService.loginUser(data)
      .then((response) => {
        dispatch(getTokenSuccess(response));
      })
      .catch((error) => {
        dispatch(getTokenError(error.data));
      });
  };
}

export function logoutUser() {
  return function (dispatch) {
    return UsersService.logoutUser()
      .then((response) => {
        PermissionsService.clean();
        dispatch(logoutSuccess(response));
      })
      .catch((error) => {
        dispatch(logoutError(error.data));
      });
  };
}

export function getUsers() {
  return function (dispatch) {
    dispatch(getUsersLoading());
    return UsersService.getUsers()
      .then((response) => {
        dispatch(getUsersSuccess(response));
      })
      .catch((response) => {
        dispatch(getUsersError(response.data));
      });
  };
}

export function getUserInfo(userId) {
  return function (dispatch) {
    dispatch(getUserLoading());
    return UsersService.getUserInfo(userId)
      .then((response) => {
        dispatch(getUserSuccess(response));
      })
      .catch((response) => {
        dispatch(getUserError(response.data));
      });
  };
}

export function getUserProfile() {
  return function (dispatch) {
    dispatch(getUserLoading());
    return UsersService.getProfile()
      .then((response) => {
        const user = response.userDetails || response;
        dispatch(getUserSuccess(user));
      })
      .catch((error) => {
        dispatch(getUserError(error.data));
      });
  };
}

export function getTestCenterPersonnel(userId) {
  return function (dispatch) {
    return Promise.all([UsersService.getTestCenterEventPersonnel(userId),UsersService.getTestCenterCyclePersonnel(userId)])
      .then((response) => {
       dispatch(getPersonnel(response));
      });
  };
}

export function updateUserInfo(userInfo) {
  return function (dispatch) {
    dispatch(updateUserLoading());
    return UsersService.setUserInfo(userInfo)
      .then((response) => {
        dispatch(updateUserSuccess(response));
      })
      .catch((error) => {
        dispatch(updateUserError(error.data));
      });
  };
}

export function createUserInfo(userInfo) {
  return function (dispatch) {
    return UsersService.createPersonnel(userInfo)
      .then((response) => {
        dispatch(createPersonnelSuccess(response));
      })
      .catch((error) => {
        dispatch(createPersonnelError(error.data));
      });
  };
}

export function getUserRoles() {
  return function (dispatch) {
    dispatch(getRolesLoading());
    return UsersService.getUserRoles()
      .then((response) => {
        dispatch(getRolesSuccess(response));
      })
      .catch((error) => {
        dispatch(getRolesError(error.data));
      });
  };
}

export function getAccountTerms(userPool) {
  return function (dispatch) {
    return UsersService.getAccountTerms(userPool)
      .then((response) => {
        dispatch(getTermsSuccess(response));
      })
      .catch((error) => {
        dispatch(generalError(error.data));
      });
  };
}

export function createPersonnel(data) {
  return function (dispatch) {
    return UsersService.createPersonnel(data)
      .then((response) => {
        dispatch(createPersonnelSuccess(response));
      })
      .catch((error) => {
        dispatch(createPersonnelError(error.data));
      });
  };
}

export function createUser(userData, personnelData) {
  return function (dispatch) {
    return UsersService.createUser(userData)
      .then((response) => {
        dispatch(createUserSuccess(response));
      })
      .catch((error) => {
        dispatch(createUserError(error.data));
      });
  };
}

export function getConfigSecurityQuestions() {
  return function (dispatch) {
    return UsersService.getSecurityQuestions()
      .then((response) => {
        dispatch(getSecurityQuestionsSuccess(response));
      })
      .catch((error) => {
        dispatch(getSecurityQuestionsError(error.data));
      });
  };
}

export function verifyUser(data) {
  return function (dispatch) {
    return UsersService.verifyUser(data)
      .then(() => {
        dispatch(verifyUserSuccess());
      })
      .catch((error) => {
        dispatch(verifyUserError(error.data));
      });
  };
}

export function updateForgotPassword(data) {
  return function (dispatch) {
    return UsersService.completeForgotPassword(data)
      .then((response) => {
        dispatch(updateForgotPasswordSuccess(response));
      })
      .catch((error) => {
        dispatch(updateForgotPasswordError(error.data));
      });
  };
}

export function resendVerification(data) {
  return createDispatchFunction(
    partial(UsersService.resendVerification, data),
    resendVerificationAction
  );
}

export function changePassword(data) {
  return function (dispatch) {
    return UsersService.changePassword(data)
      .then((response) => {
        dispatch(changePasswordSuccess(response));
      })
      .catch((error) => {
        dispatch(changePasswordError(error.data));
      });
  };
}
